
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.522 13.763h.062l.14-.611 2.037.734-.106-.37-1.583-1.432a.23.23 0 01-.066-.27c.145-.63.203-1.279.171-1.925V8.094h1.839l3.457 1.504c.188.124.368.257.541.4.268.225.203.159.203.159V9.91l-.375-.55a1.135 1.135 0 00-.312-.28L9.831 6.483l.128-.299h.128c.06-.24.097-.484.11-.73 0-.291 0-.594-.185-.594h-.56a.155.155 0 00-.14.158 4.231 4.231 0 00-.035.528c0 .097.106.633.106.633L8.155 5.3V3.075S8.094 1.439 7.5 1.096c-.594.343-.655 1.979-.655 1.979V5.3l-1.228.88s.089-.536.106-.633a4.231 4.231 0 00-.035-.528.155.155 0 00-.14-.158h-.56c-.18 0-.184.303-.184.594.012.246.05.49.11.73h.127l.128.299-3.7 2.595c-.12.074-.226.17-.311.282l-.375.549v.247s-.065.066.203-.159a6.29 6.29 0 01.54-.4l3.467-1.486h1.883v1.794a7.067 7.067 0 00.17 1.927.23.23 0 01-.065.268l-1.584 1.434-.105.369 2.036-.734.141.61h.062l-.009-.017z"}})])
          )
        }
      }
    